export default {
    data () {
      return {
        isRequestLoading: false, // 用于实例详情，各个弹窗的操作请求发出后，未响应的时间段，不能点击其余按钮
      };
    },
    methods: {
        handleEmit () {
            this.$emit('sendedRequest', this.isRequestLoading);
        }
    },
    watch: {
        isRequestLoading () {
            this.handleEmit();
        }
    },
};



// WEBPACK FOOTER //
// ./src/mixins/instanceDetailRequest.js